import domWrap from '../utils/domWrap';
import offCanvas from '../utils/offCanvas';
import monthPicker from '../utils/monthPicker';
import h from '../utils/htm';
import loadData from '../utils/loadJSONP';
import getMonths from '../utils/getMonths';

const months = getMonths('short');


const autoload = window.location.hash !== '' ? window.location.hash.split('#')[1] : false;

export default async press => { // 'comp-press'
	const count = press.getAttribute('count'),
		endpoint = press.getAttribute('endpoint'),
		resourcePath = press.getAttribute('resourcePath'),
		defaultBrand = press.getAttribute('default'),
		input = press.querySelector('input.cal'),
		container = press.querySelector('[no-results]'),
		button = h('button class="load-more btn"', 'Load More').Node,
		slideOut = offCanvas({ direction: 'right', className: 'full-screen' });
	let currentPage = 0;

	container.appendChild(button);
	button.addEventListener('click', () => refreshView(currentPage + 1));

	function refreshView(pageNumber) {
		let range = getRange(input?.value || '');
		console.log(range);
		if (!range) return;

		container.classList.add('loading');

		if (typeof pageNumber !== 'number') {
			[...container.querySelectorAll(':scope > [data-node-name]')].forEach(item => item.remove());
		}

		loadData({
			url: endpoint, // https://cmspublish-dtna.prd.freightliner.com/bin/dtna/json/service?callback=JsonReturn&requesttype=pressrelease&nodename=western-star-partners-with-namco-to-2016-02-29&_=1456936893028
			name: 'JsonReturn',
			data: {
				brandname: defaultBrand,
				pagesize: count,
				pagenumber: typeof pageNumber === 'number' ? pageNumber : 1,
				daterange: range,
				requesttype: 'pressrelease'
			}
		}).then(data => {
			data.resultHolder.forEach(item => {
				container.insertBefore(h('div data-node-name="' + item.pressReleaseNodeName + '"',
					h('span class="date"', formatDate(item.pressReleaseDate))
						('span class="title"', item.pressReleaseTitle)).Node, button);
			});
			currentPage = data.pageNumber;
			container.classList.remove('loading');
			container.classList[data.totalResults <= data.pageNumber * data.pageSize ? 'add' : 'remove']('no-more');
			container.classList[data.totalResults === 0 ? 'add' : 'remove']('none');
		});
	}

	function formatDate(date) {
		var d = new Date(date);
		return h('span class="month"', months[d.getMonth()])
			('span class="day"', d.getDate());
	}

	function loadItem(nodeName, component, after) {
		if (component) {
			component.classList.add('loading');
		}
		loadData({
			url: endpoint,
			name: 'JsonReturn',
			data: {
				nodename: nodeName,
				requesttype: 'pressrelease'
			}
		}).then(data => {
			var results = data.detailQueryResultHolder;
			if (component) {
				component.classList.remove('loading');
			}
			if (results && results.pressReleaseArticle) {
				window.location.hash = nodeName;
				slideOut.content(
					h('header',
						h('button class="close"')
							('h1', results.pressReleaseTitle)
					)
						('inner-content',
							h('h2', results.pressReleaseTitle)
								('div class="date"', results.pressReleaseDate)
							+ results.pressReleaseArticle +
							(results.downloadImages.length ? h('div class="images"',
								h('h4', 'Images:') +
								results.downloadImages.reduce(function (html, cur) {
									return html + h('div class="image"',
										h('img src="' + resourcePath + cur.lowResPath + '"')
											(cur.cutline ? 'h5' : '', cur.cutline)
											(cur.lowResPath ? 'a href="' + resourcePath + cur.lowResPath + '" download' : '', 'Download Lo-Res File')
											(cur.mediumResPath ? 'a href="' + resourcePath + cur.mediumResPath + '" download' : '', 'Download Med-Res File')
											(cur.highResPath ? 'a href="' + resourcePath + cur.highResPath + '" download' : '', 'Download High-Res File')
									);
								}, '')
							) : '')
						), function (el) {
							[...domWrap(el).on('click', '.close', () => {
								slideOut.hide();
								window.location.hash = '';
							}).querySelectorAll('a')].forEach(a => a.setAttribute('target', '_blank'));

						}).show();
			}
			if (after) {
				after();
			}
		});
	}

	monthPicker(input);

	input.addEventListener('change', () => {
		refreshView();
	});

	domWrap(container).on('click', '[data-node-name]', function () {
		loadItem(this.getAttribute('data-node-name'), this);
	});

	if (autoload) {
		container.classList.add('loading');
		loadItem(autoload, false, refreshView);
	}
	else {
		refreshView();
	}
};

function daysInMonth(month, year) {
	return new Date(year, month, 0).getDate();
}

function getRange(str) {
	var month, year;
	if (str.indexOf('undefined') !== -1) return false;
	if (!str) {
		return '2001/01/01-' + ((new Date()).getFullYear() + 1) + '/01/01';
	}
	month = str.split('-')[1];
	year = str.split('-')[0];

	return year + '/' + month + '/01-' + year + '/' + month + '/' + daysInMonth(month, year);
}